module.exports = __webpack_public_path__ + "static/features-seo-audit-4e10a36a8bc67e6de76cd2aceae047f3.jpg";